// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"5afd150f","842":"2f62c546","956":"41941865"}[chunkId] + ".chunk.js";
};